import http, { AUTH_ROUTES } from "../../../services/api";

export const getFAQs = async (setFAQs, setLoading, setError) => {
  try {
    const result = await http.get(AUTH_ROUTES.GET_FAQ);
    setFAQs(result?.data?.details?.data?.question || []);
    setError?.(null);
  } catch (e) {
    console.error("Error fetching FAQs", e?.response);
    setError?.(e?.response?.data?.message || "Failed to load FAQs");
  } finally {
    setLoading(false);
  }
};
